<template>
	<div class="modal fade component-modal" :id="id">
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<form :id="id+'-form'" :encype="encype">
					<div class="modal-header">
						<h5 class="moda-title m-0">{{title}}</h5>
					</div>
					<div class="modal-body">
						<div class="row align-items-end">
							<slot :data="data" :selected="selected" :id="id" :working="working"></slot>
							<input type="hidden" name="_token" v-bind:value="csrf">
						</div>
					</div>
					<div class="modal-footer buttons">
						<div>
							<button type="button" :disabled="working" data-dismiss="modal" class="btn btn-light btn-sm">Cancelar</button>
						</div>
						<div class="text-right" v-if="!buttons || buttons == 'true'">
							<button hidden type="submit" :id="id+'-submit'" class="btn btn-info btn-sm">Submit</button>
							<button type="button" :id="id+'-save'" :disabled="working" class="btn btn-info btn-sm">Guardar</button>
							<button type="button" :id="id+'-saveExit'" :disabled="working" class="btn btn-primary btn-sm">Guardar y Salir</button>
						</div>
						<div class="text-right">
							<slot name="footer" :id="id" :selected="selected" :disabled="working" ></slot>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from 'axios';

export default {
	props: [
	'title',
	'id',
	'post',
	'get',
	'buttons',
	'encype',
	'postOptions',
	'filesAtributes',
	'cleanOff'
	],
	data() { return {
		data: {},
		exit: false,
		selected: '',
		working: false,
		csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
	}},
	mounted() {

		const vm = this;
		const modal = $('#'+this.id);
		const form = $('#'+this.id+'-form');
		const save = $('#'+this.id+'-save');
		const saveExit = $('#'+this.id+'-saveExit');
		const submit = $('#'+this.id+'-submit');
		var applyMultipartHeaders = false;

		modal.on('show.bs.modal', function (event) {
			if (event.target.id == vm.id) {
                if(vm.get !== undefined) { // Cuando la opción es editar registro
                	vm.selected = $(event.relatedTarget).find("span[class=btnModalGetClass]").html();
                	vm.preGet(`${vm.get}${vm.selected ? '/' + vm.selected : '' }`);
                } else { // Cuando la opción es crear registro
                	vm.$emit('broadcastOpenModal', true);
                }
            }
        });
		modal.on('hide.bs.modal', function (event) {
			if (event.target.id == vm.id) {
				vm.$emit('broadcastCloseModal');
			}
		});

		save.on('click', function() {
			vm.exit = false;
			submit.click();
		});
		saveExit.on('click', function() {
			vm.exit = true;
			submit.click();
		});

		form.submit(function(event) {
			event.preventDefault();

			if (vm.post !== undefined) {
				vm.working = true;
				const data = new FormData(this);
				if (Array.isArray(vm.filesAtributes)){
					vm.filesAtributes.map(e => {
						data.append(e, vm.data[e])
					})
				}
				vm.postM(data, applyMultipartHeaders);
				vm.clearForm();

			}

		});

		this.$parent.$on('kiraModalFormClose', function() {
			modal.modal('hide');
		});

		this.$on('emitRefreshSelection', function(who, val){
			this.$emit('broadcastRefreshSelection', who, val);
		});
	},
	methods: {
		clearForm () {
			if (!this.cleanOff) {
				const vm = this;
				const attributes = Object.keys(this.data);
				attributes.map( attribute => {
					vm.data[attribute] = null
				});
			}
		},
		postM(data, applyMultipartHeaders) {

			setTimeout(() => {
				let functionParameters = [
					`${this.post}${this.selected ? '/' + this.selected : '' }`, 
					data
				]
				if (this.postOptions instanceof Object){
					functionParameters.push(this.postOptions)
				}
				axios.post(...functionParameters).then(response => {

					this.working = false;
					if (response.data.errors){
						response.data.errors.forEach(e => {
							toastr["error"]( e , "Error");
						});
					}else{
						toastr["success"](response.data.message, "Éxito");
					}

					if (this.exit == true) {							
						$('#'+this.id).modal('hide');
						this.$emit('broadcastCloseModal');
					}
				}).catch(e => {

					this.working = false;
					if (e.response && e.response.data && e.response.data.message ) {							
						toastr["error"]('Error', e.response.data.message);
					} else {
						toastr["error"]('Ocurrió un problema inesperado', e);
					}
				});

			}, 1000);
		},
		async preGet(url) {
			await this.getM(url);
			this.$emit('broadcastOpenModal', false);
		},
		async getM(url) {
			setTimeout(() => {
				return new Promise(resolve => {
					Axios.get(url).then(res => {
						this.data = res.data;
						resolve(true);
					}).catch(e => {
						resolve(false);
					});
				});
			}, 1000);
		},
		setDataModal (data, selected = null) {
			this.data = {...this.data || {} , ...data || {} }
			if (selected){
				this.selected = selected
			}
		},
		openModal (refresh) {
			if (Array.isArray(refresh)){
				for (let i = 0, length = refresh.length; i < length; i++) {
					const element = refresh[i];
					this.$emit('broadcastRefreshSelection', element);
				}
			}
			$('#'+this.id).modal('show');
		}
	}
}
</script>
